import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ProgressLabelState } from '../../enum/progress-label-state.enum';
import { MatIcon } from '@angular/material/icon';
import { LabelSize } from '../../enum/label-size.enum';

@Component({
  selector: 'lib-progress-label',
  imports: [MatIcon],
  templateUrl: './progress-label.component.html',
  styleUrl: './progress-label.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProgressLabelComponent {
  size = input<LabelSize>(LabelSize.default);
  state = input<ProgressLabelState>(ProgressLabelState.future);
  stepNumber = input<number | undefined | null>();
  titleText = input.required<string>();
  protected readonly LabelState = ProgressLabelState;
  protected readonly LabelSize = LabelSize;
}
